import socketOI from 'socket.io-client';
import { BASE_URL } from '../../../constants';

const socketOIClient = (userId, token) => socketOI.connect(BASE_URL, {
  transports: ['websocket'],
  query: `userId=${userId}&token=${token}`
});

export default socketOIClient;